<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="75%">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>{{ user.name }}'s Active Sessions</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-table>
                            <thead>
                            <tr>
                                <th class="font-weight-bold">Role</th>
                                <th class="font-weight-bold">Role Type</th>
                                <th class="font-weight-bold">Portal</th>
                                <th class="font-weight-bold">Company</th>
                                <th class="font-weight-bold">IP</th>
                                <th class="font-weight-bold">User Agent</th>
                                <th class="font-weight-bold">Created At</th>
                                <th class="font-weight-bold">Last Active At</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="session in sessions" v-if="sessions && sessions.length" :key="session.id"
                                class="text-left">
                                <td class="text-capitalize">{{ session.role?.title }}</td>
                                <td class="text-capitalize">{{ session.role?.role_type }}</td>
                                <td class="text-capitalize">{{ session.portal?.name }}</td>
                                <td class="text-capitalize">{{ session.company?.company_name }}</td>
                                <td>{{ session.ip_address }}</td>
                                <td>{{ session.user_agent }}</td>
                                <td>{{ formatDateTime(session.created_at) }}</td>
                                <td>{{ formatDateTime(session.updated_at) }}</td>
                            </tr>
                            <tr v-else>
                                <td v-if="!sessions" class="text-center" colspan="8">
                                    <v-progress-circular color="primary" indeterminate size="small"/>
                                </td>
                                <td v-else class="text-center" colspan="8">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button"
                       @click="$emit('update:modelValue',false)">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {formatDateTime} from "@/composables/useTimezone";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    user: Object,
});

const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const sessions = ref(null);
const errors = ref([]);

onMounted(() => {
    fetchSessions()
})

const fetchSessions = () => {
    errors.value = [];
    send('get', `users/${props.user.id}/active-sessions`)
        .then((response) => {
            sessions.value = response.data.data;
        })
        .catch(function (errorResponse) {
            snackbar.showSnackbar(errorResponse ?? 'Something went wrong', 'error');
        })
}
</script>
